import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-fc56f926"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "item-box" };
const _hoisted_2 = ["onClick"];
const _hoisted_3 = { class: "item-text" };
import { useCounterStore } from "@/store/user";
export default /*#__PURE__*/ _defineComponent({
    name: 'index',
    props: {
        data: { default: () => [] },
        disabled: { type: Boolean, default: false },
        checkAuth: { type: Boolean, default: false }
    },
    setup(__props) {
        const userStore = useCounterStore();
        const userType = userStore.getUserInfo.type;
        const hasPermission = (item) => {
            if (!item.checkAuth) {
                return true;
            }
            return userType !== "sub";
        };
        const itemClick = (disabled, callback) => {
            if (disabled) {
                return;
            }
            callback?.();
        };
        return (_ctx, _cache) => {
            const _component_svg_icon = _resolveComponent("svg-icon");
            const _component_el_tooltip = _resolveComponent("el-tooltip");
            const _component_el_dropdown = _resolveComponent("el-dropdown");
            return (_openBlock(), _createBlock(_component_el_dropdown, {
                disabled: __props.disabled,
                class: "menu",
                "popper-class": "my-dropdown-popper-arrow my-popper"
            }, {
                dropdown: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.data, (item) => {
                            return (_openBlock(), _createBlock(_component_el_tooltip, {
                                key: item.name,
                                disabled: hasPermission(item) && !item.tips,
                                class: "box-item",
                                "raw-content": item.rawContent,
                                effect: "dark",
                                content: !hasPermission(item) ? '子用户不支持该操作' : item.tips,
                                placement: "top"
                            }, {
                                default: _withCtx(() => [
                                    _createElementVNode("div", {
                                        class: _normalizeClass(["item", { disabled: item.disabled || !hasPermission(item) }]),
                                        onClick: ($event) => (itemClick(item.disabled || !hasPermission(item), item.callback))
                                    }, [
                                        (item.icon)
                                            ? (_openBlock(), _createBlock(_component_svg_icon, {
                                                key: 0,
                                                "icon-class": item.icon
                                            }, null, 8, ["icon-class"]))
                                            : _createCommentVNode("", true),
                                        _createElementVNode("span", _hoisted_3, _toDisplayString(item.name), 1)
                                    ], 10, _hoisted_2)
                                ]),
                                _: 2
                            }, 1032, ["disabled", "raw-content", "content"]));
                        }), 128))
                    ])
                ]),
                default: _withCtx(() => [
                    _renderSlot(_ctx.$slots, "default")
                ]),
                _: 3
            }, 8, ["disabled"]));
        };
    }
});
